// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"82600d70","977":"574814a2"}[chunkId] + ".chunk.js";
};